import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { LogoMark } from "../site/Logo";
import axios, { AUTH_API, TOKEN_KEY, formatError } from "../../lib/api";

export const AdminLogin = ({ onLogin, initialError = "" }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(initialError);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${AUTH_API}/auth/login`, { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      onLogin(data.user);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-sm rounded-[28px] border hairline bg-[var(--forest-2)] p-8">
        <LogoMark className="h-12 w-9" />
        <h1 className="mt-6 font-display text-3xl font-bold">Plant team login</h1>
        <p className="mt-1 text-sm text-[var(--sage)]">Update production, stock and orders.</p>
        <button type="button" data-testid="admin-google-login-button" onClick={google} className="mt-8 w-full h-12 rounded-full bg-[var(--cream)] text-[var(--forest)] font-semibold inline-flex items-center justify-center gap-3 transition-transform hover:-translate-y-0.5">
          <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.5 30.2 0 24 0 14.6 0 6.6 5.4 2.7 13.3l7.8 6C12.4 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4 7.1-10 7.1-17.5z"/><path fill="#FBBC05" d="M10.5 28.7A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.7l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6z"/><path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.9 2.3-8.4 2.3-6.3 0-11.6-4.2-13.5-9.9l-7.9 6C6.5 42.6 14.6 48 24 48z"/></svg>
          Continue with Google
        </button>
        <div className="mt-6 flex items-center gap-3 font-mono text-[11px] uppercase tracking-wider text-[var(--sage)]"><span className="h-px flex-1 bg-white/10" />or email<span className="h-px flex-1 bg-white/10" /></div>
        <div className="mt-6 space-y-4">
          <div className="space-y-1.5"><Label htmlFor="em">Email</Label><Input id="em" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" /></div>
          <div className="space-y-1.5"><Label htmlFor="pw">Password</Label><Input id="pw" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" /></div>
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-300">{error}</p>}
        <button data-testid="admin-login-button" disabled={busy} className="mt-6 w-full h-12 rounded-full bg-[var(--husk)] text-[var(--forest)] font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Log in
        </button>
        <a href="/" data-testid="admin-back-link" className="mt-6 block text-center text-sm text-[var(--sage)] hover:text-[var(--cream)]">← Back to site</a>
      </form>
    </div>
  );
};
